import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { AuthService } from './auth.service'

export const isAuthenticated: CanActivateFn = () => {
  const authService = inject(AuthService)
  const router = inject(Router)

  return authService.isAuthenticated().then((signedIn) => {
    if (!signedIn) {
      return router.createUrlTree(['/login'])
    }
    return true
  })
}

export const isAnonymous: CanActivateFn = () => {
  const authService = inject(AuthService)
  const router = inject(Router)

  return authService.isAuthenticated().then((signedIn) => {
    if (signedIn) {
      return router.createUrlTree(['/'])
    }
    return true
  })
}
